import { ImportDataComponent } from './import-data.component';
export var importDataRoutes = [
    {
        path: 'import-data',
        component: ImportDataComponent
    }
];
var ImportDataRoutingModule = (function () {
    function ImportDataRoutingModule() {
    }
    return ImportDataRoutingModule;
}());
export { ImportDataRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data-routing.module.ts.pre-build-optimizer.js